import React from "react";
import {
  Card as MaterialUICard,
  CardContent,
  Typography,
  Button,
  Badge,
  Divider,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Link, graphql, useStaticQuery } from "gatsby";
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image"; // Import getImage
import { useLocation } from "@reach/router";
import airCallLogo from "../../../images/v2/crm-integration/logo/aircallLogo.svg";
import confluenceLogo from "../../../images/v2/crm-integration/logo/confluenceLogo.svg";
import dearSystem from "../../../images/v2/crm-integration/logo/dearSystemLogo.svg";
import facebookLogo from "../../../images/v2/crm-integration/logo/facebookLogo.svg";
import facebookMessangerLogo from "../../../images/v2/crm-integration/logo/facebookMessangerLogo.svg";
import gmailLogo from "../../../images/v2/crm-integration/logo/gmailLogo.svg";
import googleCalendarLogo from "../../../images/v2/crm-integration/logo/googleCalendarLogo.svg";
import googleContactsLogo from "../../../images/v2/crm-integration/logo/googleContactLogo.svg";
import googleDriveLogo from "../../../images/v2/crm-integration/logo/googleDriveLogo.svg";
import googleFormsLogo from "../../../images/v2/crm-integration/logo/googleFormsLogo.svg";
import googleSheetLogo from "../../../images/v2/crm-integration/logo/googleSheetLogo.svg";
import instagramLogo from "../../../images/v2/crm-integration/logo/instagramLogo.svg";
import jiraLogo from "../../../images/v2/crm-integration/logo/jiraLogo.svg";
import krispcallLogo from "../../../images/v2/crm-integration/logo/krispcallLogo.png";
import linkedinLogo from "../../../images/v2/crm-integration/logo/linkedinLogo.svg";
import mailchimpLogo from "../../../images/v2/crm-integration/logo/mailchimpLogo.svg";
import mailerLiteLogo from "../../../images/v2/crm-integration/logo/mailerLiteLogo.svg";
import onedriveLogo from "../../../images/v2/crm-integration/logo/onedriveLogo.svg";
import outlookLogo from "../../../images/v2/crm-integration/logo/outlookLogo.svg";
import outlookCalendarLogo from "../../../images/v2/crm-integration/logo/outlookCalendarLogo.svg";
import outlookContactLogo from "../../../images/v2/crm-integration/logo/outlookContactLogo.svg";
import quickBookLogo from "../../../images/v2/crm-integration/logo/quickBookLogo.svg";
import shopifyLogo from "../../../images/v2/crm-integration/logo/shopifyLogo.svg";
import telegramLogo from "../../../images/v2/crm-integration/logo/telegramLogo.svg";
import whatsappTwilioLogo from "../../../images/v2/crm-integration/logo/whatsappTwilioLogo.svg";
import whatsappMetaLogo from "../../../images/v2/crm-integration/logo/whatsappMetaLogo.svg";
import whatsappLogo from "../../../images/v2/crm-integration/logo/whatsappLogo.svg";
import xeroLogo from "../../../images/v2/crm-integration/logo/xeroLogo.svg";
import zoomLogo from "../../../images/v2/crm-integration/logo/zoomLogo.svg";
import forwardArrowIcon from "../../../images/v2/crm-integration/logo/forwardArrowIcon.svg";

const HomeCard = ({
  backgroundColor,
  link,
  badgeText,
  badgeColor,
  badgeBackground,
  heading,
  description,
  id,
}) => {
  const logos = [
    <img
      alt="aircall_logo"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={airCallLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Dear_Systems"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={dearSystem}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Facebook_lead_form"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={facebookLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="facebook_messenger"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={facebookMessangerLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="gmail"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={gmailLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="google-calender"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={googleCalendarLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="google-contacts"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={googleContactsLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="google-drive"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={googleDriveLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="google-forms"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={googleFormsLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="instagram"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={instagramLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="LinkedIn"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={linkedinLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Mailchimp"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={mailchimpLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="MailerLite"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={mailerLiteLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "90px",
        height: "90px",
      }}
    />,
    <img
      alt="One Drive"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={onedriveLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Outlook"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={outlookLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Outlook Calender"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={outlookCalendarLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Outlook Contacts"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={outlookContactLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="QuickBooks"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={quickBookLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Shopify"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={shopifyLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Telegram"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={telegramLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="WhatsApp"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={whatsappMetaLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Xero"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={xeroLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Zoom"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={zoomLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="Whatsapp Twilio"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={whatsappTwilioLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="jira"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={jiraLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="google sheet"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={googleSheetLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="whatspa"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={whatsappLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="whatspa"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={krispcallLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
    <img
      alt="confluence"
      fit="cover"
      height={50}
      layout="constrained"
      placeholder="blured"
      src={confluenceLogo}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        overflow: "auto",
        width: "60px",
        height: "60px",
      }}
    />,
  ];

  const backgrounds = [
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/aircall 55352@2x.png"
      alt="aircall Background 1"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Dear-grad 8226@2x.png"
      alt="Dear-grad Background 2"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Facebook-lead-form grad.png"
      alt="Facebook-lead-form Background 3"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/facebook-messenger 6168@2x.png"
      alt="Facebook Messenger Background 4"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Gmail-grad 55351@2x.png"
      alt="Gmail Background 5"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Google-calender-grad.png"
      alt="Google Calender Background 6"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/google-contacts-grad.png"
      alt="Google Contacts Background 7"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/google-drive-grad.png"
      alt="google drive Background 8"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/google-forms-grad.png"
      alt="Google forms Background 9"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/instagram-grad.png"
      alt="Instagram Background 10"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/LinkdIn-grad.png"
      alt="LinkdIn Background 11"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Mailchimp grad.png"
      alt="Mailchimp Background 12"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Mailerlite-grad.png"
      alt="Mailerlite Background 13"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/one-drive-grad.png"
      alt="Onedrive Background 14"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/outlook-grad.png"
      alt="Outlook Background 15"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/outlook-calender-grad.webp"
      alt="Outlook-Calender Background 16"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/outlook-contacts-grad.png"
      alt="Outlook-Contacts Background 17"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Quickbooks-grad.png"
      alt="Quickbooks-Background 18"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Telegram.png"
      alt="Telegram-Background 20"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Whatsapp-grad.png"
      alt="Whatsapp-Background 21"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Zoom-grad.png"
      alt="Zoom-Background 23"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Xero-grad.png"
      alt="Xero-Background 22"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Telegram.png"
      alt="Zoom-Background 23"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    <StaticImage
      src="../../../images/v2/crm-integration/card-gradient-bg/Telegram.png"
      alt="Zoom-Background 23"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderTopLeftRadius: 21,
        borderTopRightRadius: 21,
        overflow: "visible",
      }}
    />,
    // ... add more background images as needed
  ];

  const logo = logos[id - 1];
  const background = backgrounds[id - 1];
  const location = useLocation();
  return (
    <MaterialUICard
      component={"a"}
      className="mobileCard"
      style={{ cursor: "pointer" }}
      href={link}
    >
      <CardContent
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: 0,
          position: "relative",
        }}
      >
        {/* Background Image */}
        <div style={{ position: "relative" }}>
          {background}

          {/* Logo Image (overlaps background image) */}
          {logo ? logo : null}
          {/* // <GatsbyImage src={logo} alt="Logo"  />} */}
        </div>

        {/* <Divider style={{ width: '100%', marginBottom: '10px' }} /> */}
        <div
          style={{
            width: "100%",
            position: "relative",
            border: "solid 1px #7fcbe7",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "24px 16px",
            borderRadius: 21,
            borderTop: "none",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            height: "175px",
          }}
        >
          {badgeText && (
            <div
              style={{
                borderRadius: "4px",
                backgroundColor: badgeBackground,
                color: badgeColor,
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "28px",
                padding: "0.25rem 0.75rem",
                position: "absolute",
                top: "-1rem",
              }}
            >
              {badgeText}
            </div>
          )}

          <Typography
            variant="h5"
            gutterBottom
            style={{
              marginBottom: "10px",
              fontWeight: "bold",
              fontSize: "22px",
              paddingTop: "18px",
            }}
          >
            {heading}
          </Typography>
          {/* Description */}
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            style={{ marginBottom: "10px" }}
          >
            {description}
          </Typography>
        </div>

        <Link
          // onClick={()=>window.location.reload()}
          to={link}
          target="_blank"
          style={{
            position: "absolute",
            bottom: "-22px",
            right: "20px",
            zIndex: 10,
          }}
        >
          <img
            src={forwardArrowIcon}
            alt="Arrow"
            height={40}
            style={{ cursor: "pointer" }}
          />
        </Link>
      </CardContent>
    </MaterialUICard>
  );
};

export default HomeCard;
